import Vuex from 'vuex'
import http from './http'

Vue.use(Vuex)

const state = {
  global_config: {},
  global_config_loaded: false,
  common: {
    scrollPos: {}
  }
}

const mutations = {
  changeLoadGlobalConfigStatus(state, payload){
    state.global_config_loaded = payload;
  },
  setGlobalConfig (state, payload){
    state.global_config = payload;
  },
  setPageScrollPos (state, payload){
    state.common.scrollPos[payload.routeName] = payload.scrollPosTop;
  }
}


const actions = {

  loadGlobalConfig (context){
    return new Promise((resolve, reject) => {
        http.get('/mag/index/v1/Index/config', {
          needLoadingIndicator: false
        }, function (res) {
          context.commit('setGlobalConfig', res.data);
          context.commit('changeLoadGlobalConfigStatus', true);
          resolve(res.data);
        });
    });
  },

  updatePageScrollTop (context, position){
    context.commit('setPageScrollPos', position);
  }

}

const getters = {
  global_config: state => {
    return state.global_config
  },
  global_config_loaded: state =>{
    return state.global_config_loaded
  }
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/common/store.js